export default {
  apiEndPoint: process.env.VUE_APP_API,
  appTitle: process.env.VUE_APP_NAME,
  appId: process.env.VUE_APP_ID
}
